import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useToast } from '../../../../../shared/toastMessages/toastProvider';

import patchApiData from "../../../../../../hooks/apiRequests/patchRequest";
import getApiData from "../../../../../../hooks/apiRequests/getRequest";

const DisableTenant = ({ setError }) => {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(false);
  const { company } = useParams();
  const { showToast } = useToast();

  // Fetch tenant config on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getApiData(`/Configs/Specific?name=0`);
        setTenant(response.data);
        showToast("Failed to load data. Redirecting to login...", "success");
      } catch (error) {
        console.error("Error fetching tenant config:", error);
        showToast("Failed to load data. Redirecting to login...", "error");
      }
    };

    fetchData();
  }, [company, showToast, setError]);

  // Toggle tenant state
  const handleToggle = async () => {
    if (!tenant) return;

    setLoading(true);
    const newState = tenant.config_value === 1 ? 0 : 1;

    const body = {
      name: company,
      config_value: newState,
    };

    try {
      const response = await patchApiData(`/DisableTenant`, body);
      if (response) {
        // Update state locally to reflect the change
        setTenant((prev) => ({ ...prev, config_value: newState }));
        setError("");
      } else {
        setError("Failed to update tenant state");
      }
    } catch (err) {
      console.error("Error processing request:", err);
      setError("Unable to update tenant state");
    } finally {
      setLoading(false);
    }
  };

  if (!tenant) {
    return <Button disabled>Loading...</Button>;
  }

  const isDisabled = tenant.config_value === 0;

  return (
    <Button
      variant="contained"
      onClick={handleToggle}
      sx={{ m: 1 }}
      color={isDisabled ? "success" : "error"}
      disabled={loading}
    >
      {loading
        ? "Processing..."
        : isDisabled
        ? "Enable Tenant"
        : "Disable Tenant"}
    </Button>
  );
};

export default DisableTenant;
